import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AppState } from '../index';
import { Store } from '@ngrx/store';

import { catchError, map, mergeMap, tap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { BatchService } from '../../data/batch.service';
import { BatchFilterService } from '../../modules/shared/filter/batch-filter.service';
import {
    batchTableAddAssist,
    batchTableChangePage, batchTableChangeQuery,
    batchTableFailure, batchTableRemoveAssist,
    batchTableRequest,
    batchTableSort,
    batchTableSuccess
} from './batch-table.actions';
import { selectBatchTableQuery } from './batch-table.state';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class BatchTableEffects {

    constructor(private actions$: Actions, private batchService: BatchService, private store: Store<AppState>,
                private snackbar: MatSnackBar, private batchFilterService: BatchFilterService) {
    }

    batchTableRequest$ = createEffect(() => this.actions$.pipe(
        ofType(batchTableRequest),
        withLatestFrom(this.store.select(selectBatchTableQuery)),
        mergeMap(([ , query ]) => this.batchService.query(query).pipe(
            map((result) => {
                return batchTableSuccess({
                    totalCount: result['hydra:totalItems'],
                    page: result['hydra:member']
                });
            })
        )),
        catchError((e) => of(batchTableFailure()))
    ));

    batchTableFailure$ = createEffect(() => this.actions$.pipe(
        ofType(batchTableFailure),
        tap(() => this.snackbar.open($localize`We are having difficulty communicating with the server.  Please try again later.`))
    ), { dispatch: false });

    batchTableChangePage$ = createEffect(() => this.actions$.pipe(
        ofType(batchTableChangePage),
        map(() => batchTableRequest())
    ));

    batchTableChangeSort$ = createEffect(() => this.actions$.pipe(
        ofType(batchTableSort),
        map(() => batchTableRequest())
    ));

    batchTableChangeQuery$ = createEffect(() => this.actions$.pipe(
        ofType(batchTableChangeQuery),
        map(() => batchTableRequest())
    ));

    batchTableFilterAdd$ = createEffect(() => this.actions$.pipe(
        ofType(batchTableAddAssist),
        withLatestFrom(this.store.select(selectBatchTableQuery)),
        map(([ action, query ]) => this.batchFilterService.applyAssist(query, action.id, action.parameter)),
        map(query => batchTableChangeQuery({ query }))
    ));

    batchTableFilterRemove$ = createEffect(() => this.actions$.pipe(
        ofType(batchTableRemoveAssist),
        withLatestFrom(this.store.select(selectBatchTableQuery)),
        map(([ action, query ]) => this.batchFilterService.removeAssist(query, action.id)),
        map(query => batchTableChangeQuery({ query }))
    ));
}
